import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { NgProgressRef, NgProgress } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { DirectoryDeleteComponent } from 'src/app/components/dialog/references/directory-delete/directory-delete.component';
import { RereferencesActionsComponent } from 'src/app/components/dialog/references/rereferences-actions/rereferences-actions.component';
import { PaginationInput, PaginationPageEvent, ListParams, Res } from 'src/app/models';
import { ApiOrganizationsService, ApiReferencesService, DialogModalService, LanguageService, NotificationService, PermissionService } from 'src/app/services';

@Component({
  selector: 'app-references-list',
  templateUrl: './references-list.component.html',
  styleUrls: ['./references-list.component.css']
})
export class ReferencesListComponent implements OnInit {

  progressRef: NgProgressRef;
  subscriptions: Subscription = new Subscription();
  language: string;
  loading: boolean;
  references: any[] = [];
  organizations: any[] = [];
  paginationInput: PaginationInput;
  paginationOutput: PaginationPageEvent;
  listParams: ListParams;
  searchRes:any[] = [];

  form: UntypedFormGroup = this.fb.group({
    search: ['']
  })

  searchForm: UntypedFormGroup = this.fb.group({
    search: [null],
    searchReference: [null]
  })

  constructor(
    public ngProgress: NgProgress,
    private languageService: LanguageService,
    private apiReferences: ApiReferencesService,
    private notification: NotificationService,
    private dialogModal: DialogModalService,
    private apiOrganozations: ApiOrganizationsService,
    public permissionAccess: PermissionService,
    private fb: UntypedFormBuilder
  ) { }

  ngOnInit(): void {

    this.progressRef = this.ngProgress.ref('progress-bar');
    
    if(this.permissionAccess.check('REFERENCES_ORGANIZATIONS')){
      this.getOrganizations();
    }
    
    this.getList();

    this.searchForm.get('searchReference').valueChanges.subscribe(val => {

      this.getList(val);

    });

    this.form.get('search').valueChanges.subscribe(val => {

      this.getOrganizations(val);

    });


    this.subscriptions.add(
      this.languageService.listenerLanguage().subscribe(val => {

        this.language = val.language;
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  /**
   * 
   */
  getList(org_id:string = null, searchValue:string = ''): void {

    this.progressRef.start();
    this.loading = true;
    this.references = [];

    this.setListParams(searchValue, org_id);

    this.apiReferences.getList(this.listParams).subscribe((response: Res) => {
      console.log("references_RESPONSE_LIST: ", response)

      if (response.result != null) {

        // searchValue != '' ? this.references = this.references.filter(item => item.name.toLowerCase().includes(searchValue.toLowerCase())) : this.references = response.result;

        this.references = response.result.list;

        this.paginationInput = {
          count: response.result.count,
          numberOfPages: response.result.numberOfPages,
          currentPage: this.listParams.pageNumber,
          size: this.listParams.countOnPage
        }
      }

      this.progressRef.complete();
      this.loading = false;
    },
      error => {
        this.progressRef.complete();
        this.loading = false;
      });
  }

  /**
   * 
   */
  setListParams(org_id:string = null, searchValue: string = ''): void {

    this.listParams = {
      filter: {
        org_id: org_id,
        name: searchValue
      },
      object: 'references',
      pageNumber: (!this.paginationOutput || this.paginationOutput == undefined || this.paginationOutput == null) ? 1 : this.paginationOutput.pageNumber,
      countOnPage: (!this.paginationOutput || this.paginationOutput == undefined || this.paginationOutput == null) ? 10 : this.paginationOutput.pageSize
    }
  }

  /**
   * 
   */
   getOrganizations(searchValue: string = ''): void {

    this.organizations = [];

    let data = {
      ref_name: 'organizations',
      filter: {
        name: searchValue,
        sort: 'all'
      }
     }

    this.subscriptions.add(
      this.apiOrganozations.getReferences(data, data.ref_name).subscribe((response: Res) => { console.log('[RESPONSE] getOrganizations: ', response);

        if(response != null){

          this.organizations = response.result;
        }

        this.progressRef.complete();
      },
      error => { 
        this.progressRef.complete();
      })
    );
  }


  /**
   * 
   * @param event 
   */
  pageEvent(event: PaginationPageEvent): void {

    this.paginationOutput = event;
    this.getList();
  }

  /**
  * 
  */
   onCreate() {

    let data = null;

    this.dialogModal.open(data, RereferencesActionsComponent).then(
      (result) => {

        if (result) {

          this.getList();
        }
      },
      () => { console.log('Rejected!'); }
    );
  }


  /**
  * 
  * @param ids 
  */
  onDelete(id): void {

    let data = {
      reference_id: [id]
    }

    this.dialogModal.open(data, DirectoryDeleteComponent).then(
      (result) => {
      
        if (result) {
          
          this.getList();
        }
      },
      () => { console.log('Rejected!'); }
    );
  }

  /**
   * 
   */
  deleteSelected(): void {

    let ids = [...new Set(this.references.filter(val => val.checked).map(({ id }) => id))];

    let data = {
      reference_id: ids
    }

    this.dialogModal.open(data, DirectoryDeleteComponent).then(
      (result) => {

        if (result == true) {

          this.notification.show('success', 'Данные успешно удалены!');
          this.getList();
        }
      },
      () => { console.log('Rejected!'); }
    );
  }

  /**
   * 
   */
  onEdit(id:string){

    let data = {
      reference_id: id
    }

    this.dialogModal.open(data, RereferencesActionsComponent).then(
      (result) => {
      
        if (result) {
          
          this.getList();
        }
      },
      () => { console.log('Rejected!'); }
    );
  }

  /**
   * 
   */
  resetSearch(){

    this.form.reset();
    this.getList();
  }
  

  /** CHECKBOX */

  /**
   * 
   * @param index number
   * @param event 
   */
  selectedCheckBox(index: number, event: any): void {

    this.references[index].checked = event.target.checked;
  }


  /**
   * 
   * @param event 
   */
  checkAllCheckBox(event: any): void {

    this.references.forEach(x => x.checked = event.target.checked)
  }


  /**
   * 
   * @returns boolean
   */
  isAllCheckBoxChecked(): boolean {

    if(this.references) {

      if (this.references.length == 0) return false;

      return this.references.every(p => p.checked);
    }
  }


  /**
   * 
   * @returns boolean
   */
  checkedButNotAllCheckBox(): boolean {

    if(this.references) {
      
      let pl = this.references.length;
      let pc = this.references.filter(val => val.checked).length;
  
      return (pc > 0 && pc < pl) ? true : false;
    }
  }


  /**
   * 
   * @returns boolean
   */
  checkedCheckBox(): boolean {

    if(this.references) {

      let pc = this.references.filter(val => val.checked).length;

      return (pc > 0) ? true : false;
    }
  }

}
